import { useNavigate } from "react-router-dom"

export default function NotFound() {

    const navigate = useNavigate()

    const redirect = () => {

        navigate('/')
    }
    return (
        <div className="d-flex vh-100 bg-primary text-white justify-content-center align-items-center flex-column">
        <h1 className="display-1 fw-bold">404</h1>
        <p className="fs-3">Oops! Page not found.</p>
        <p className="lead">The page you’re looking for doesn’t exist or has been moved.</p>
        <button onClick={redirect} className="btn btn-light mt-3">Go Home</button>
      </div>
    )
  }